// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_er-a";
export var fulfillmentFormRail = "_er-9";
export var headerTitleRow = "_er-c";
export var orderDetailsWrapper = "_er-7";
export var orderLinkTrigger = "_er-2";
export var paymentInformationGrid = "_er-h";
export var paymentSummaryColumn = "_er-i";
export var shipmentContainer = "_er-b";
export var shipmentDetailsMainPane = "_er-8";
export var shipmentNavigationCard = "_er-5";
export var shipmentNavigationRail = "_er-3";
export var shipmentNavigationRailHeader = "_er-4";
export var shipmentSummaryFact = "_er-e";
export var shipmentSummaryGrid = "_er-d";
export var shipmentSummaryMetadataRow = "_er-f";
export var shipmentSummaryTags = "_er-g";
export var shipmentWorkspace = "_er-0";
export var shipmentWorkspaceContent = "_er-6";
export var shipmentWorkspaceHeader = "_er-1";